
// Sample states list
export const STATES = [
  { value: "AK", label: "Alaska" },
  { value: "AL", label: "Alabama" },
  { value: "AR", label: "Arkansas" },
  { value: "AZ", label: "Arizona" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DC", label: "District of Columbia" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "IA", label: "Iowa" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "MA", label: "Massachusetts" },
  { value: "MD", label: "Maryland" },
  { value: "ME", label: "Maine" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MO", label: "Missouri" },
  { value: "MS", label: "Mississippi" },
  { value: "MT", label: "Montana" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "NE", label: "Nebraska" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NV", label: "Nevada" },
  { value: "NY", label: "New York" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VA", label: "Virginia" },
  { value: "VT", label: "Vermont" },
  { value: "WA", label: "Washington" },
  { value: "WI", label: "Wisconsin" },
  { value: "WV", label: "West Virginia" },
  { value: "WY", label: "Wyoming" }
];

// Credit score ranges
export const CREDIT_SCORES = [
  { value: 580, label: "Below 580" },
  { value: 620, label: "580-619" },
  { value: 660, label: "620-659" },
  { value: 700, label: "660-699" },
  { value: 740, label: "700-739" },
  { value: 780, label: "740-779" },
  { value: 800, label: "780+" },
];

// Loan type information with updated descriptions
export const LOAN_TYPES = [
  { 
    value: "conventional", 
    label: "Conventional",
    description: "Traditional loans not backed by the government, requiring 3-20% down payment. Front-end ratio limit: 28%, Back-end ratio limit: 36%."
  },
  { 
    value: "fha", 
    label: "FHA",
    description: "Government-backed loans allowing down payments as low as 3.5% with more flexible credit requirements. Front-end ratio limit: 31%, Back-end ratio limit: 43%."
  },
  { 
    value: "va", 
    label: "VA",
    description: "Loans for veterans, service members, and eligible spouses with no down payment required. Primary focus is on residual income, with benchmark DTI of 41%, but can go higher with compensating factors."
  },
  { 
    value: "usda", 
    label: "USDA",
    description: "Government-backed loans for rural properties with no down payment required. Front-end ratio limit: 29%, Back-end ratio limit: 41%."
  },
];
